/*
 * @Author: wanganqing wanganqing0502@163.com
 * @Date: 2022-07-21 10:45:11
 * @LastEditors: wanganqing wanganqing0502@163.com
 * @LastEditTime: 2022-08-31 15:50:58
 * @FilePath: /ssr-nuxt-koa-web/components/public/hoverFixedBtn.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import hoverFixedBtnComponet from './hoverFixedBtnComponents.vue';
const hoverFixedBtn = {};
hoverFixedBtn.install = function (Vue) {
  const HoverFixedBtnControll = Vue.extend(hoverFixedBtnComponet);
  const instance = new HoverFixedBtnControll().$mount(
    document.createElement('div')
  );

  if (document && document.body && document.body.clientWidth > 768) {
    document.body.appendChild && document.body.appendChild(instance.$el);
  }
};
export default hoverFixedBtn;
